<template>
	<div>
		<loading-anim :active="$store.state.loading" fullScreen></loading-anim>
		<b-navbar v-if="!$uiHelpers.isXlDevice" toggleable="xl" :class="{ 'navbar': true, 'fixed-scroll': isFixedScrolled }">
			<b-navbar-nav class="ml-auto">
				<b-nav-item class="ml-2">
					<base-button class="btn-layout" @click="manageMenu">
						<base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/menu-icon.svg" width="23" height="23" style="color:#3238C4" color="#3238C4" />
						<!-- <span>{{ $t('menu-opt') }}</span> -->
					</base-button>
				</b-nav-item>
			</b-navbar-nav>
			<router-link to="/">
				<b-navbar-brand><img class="navbar-brand-img" color="#3238C4" style="color:#3238C4" :style="getLogoStyles" :src="getLogo" /></b-navbar-brand>
			</router-link>
			<!-- <b-navbar-toggle target="nav-collapse"></b-navbar-toggle> -->
			<b-navbar-nav class="ml-auto">
				<b-nav-item class="mr-2">
					<router-link to="/inicio-sesion">
						<base-button class="btn-layout">
							<base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/profile.svg" color="#3238C4" svgClasses="reverse" />
							<!-- <span>{{ $t('access') }}</span> -->
						</base-button>
					</router-link>
				</b-nav-item>
			</b-navbar-nav>
		</b-navbar>
		<div>
			<router-view v-slot="{ Component }">
				<transition name="fade" mode="out-in">
					<component :is="Component" />
				</transition>
			</router-view>
		</div>
	</div>
</template>

<script>
import layoutMixin from '@/mixins/layout.mixin'
import gtagMixin from '@/mixins/gtag.mixin'
import { BNavbar, BNavbarNav, BNavbarBrand, BNavbarToggle, BCollapse, BNavItem } from 'bootstrap-vue'

export default {
  mixins: [layoutMixin, gtagMixin],
  components: {
    'loading-anim': () => import('@/components/utils/LoadingAnim'),
    BNavbar,
    BNavbarNav,
    BNavbarBrand,
    BNavbarToggle,
    BCollapse,
    BNavItem
  },
  data () {
    return {
      key: this.$route.path,
      collapsed: true,
      isFixedScrolled: false
    }
  },
  methods: {
    back () {
      window.history.back()
    },
    openMenu () {
      // const navbar = document.querySelector('.navbar')
      const navbarToggler = document.querySelector('.navbar-toggler')
      const collapse = document.querySelector('.collapse ')
      navbarToggler.classList.add('not-collapsed')
      const posFixed = document.querySelector('.position-fixed')
      posFixed.classList.add('background-set')
      collapse.classList.add('show')
      collapse.classList.remove('colapse-none')
      collapse.classList.add('colapse-initial')
    },
    closeMenu () {
      // const navbar = document.querySelector('.navbar')
      const navbarToggler = document.querySelector('.navbar-toggler')
      const collapse = document.querySelector('.collapse ')
      const posFixed = document.querySelector('.position-fixed')
      posFixed.classList.remove('background-set')
      navbarToggler.classList.remove('not-collapsed')
      navbarToggler.classList.add('collapsed')
      collapse.classList.remove('show')
      collapse.classList.add('colapse-none')
      collapse.classList.remove('colapse-initial')
    },
    manageMenu () {
      if (this.collapsed === true) {
        this.openMenu()
        this.collapsed = false
      } else {
        this.closeMenu()
        this.collapsed = true
      }
    },
    handleScroll () {
      this.isFixedScrolled = window.scrollY > 50
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="scss" scoped>
  @include media(mobile, tablets) {

.ctm-container {
    @include container-padding;
    h3 {
      color: black
    }
}
/deep/ .navbar-toggler-icon {
      visibility: hidden;
  }
  /deep/ .navbar-brand {
      margin-right: 0;
  }
  /deep/ .navbar-nav{
    box-shadow: none !important;
    background-color: $blue !important;
    display: contents;

  }
 /deep/ .colapse-none{
  display: none !important;
 }
 /deep/ .colapse-initial{
  display: initial !important;
 }
 /deep/ .background-set{
  width: 50% !important;

 }

 /deep/ .navbar-collapse {
  transition: all .5s ease;
  padding: 1rem;
  text-align: center;
      background-color: $white;
      border-radius: $border-radius;
      box-shadow: $custom-shadow-bottom;
 }
   .navbar {
    // padding: 0rem 2rem;
    flex-wrap: initial;
    width: 100%;
    transform: translate3d(0, 0, 0);
    transition: 0.1s all ease-out;
    position: fixed;
    z-index: 1001;
    padding: 0rem 0rem;
    &.fixed-scroll {
      background-color: #ffffffdd;
      box-shadow: -10px -10px 35px #fff, 10px 10px 35px rgba(13,39,80,0.160784);
      border-bottom-left-radius: 18px;
      border-bottom-right-radius: 18px;
    }
    
    .btn-layout{
      @include mobile {
        font-size: 12px !important;
      }
      @include tablets {
        font-size: 17px !important;
      }
     font-weight: initial;
     padding: .7rem 1.2rem;
     border-color: transparent;
     background-color: transparent;
    }
  }


/deep/ .nav-item {
  margin-right: 0rem;
    padding: 0rem;
  }


/deep/ .navbar-brand-img {
  @include mobile {
    width: 130px;
  }
  color:white
}

/* .navbar {
  @include mobile {
    padding: 1rem;
  }
} */

/deep/.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
/deep/.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
  }

</style>


// WEBPACK FOOTER //
// src/components/layouts/PublicMobileMenuLayout.vue